import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject;
import styled from "@emotion/styled";
export var StyledInputContainer = styled("div")(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    flex: 1;\n    // So the inner input can inherit from the outer component.\n    border-radius: inherit;\n"])));
//# sourceMappingURL=StyledInputContainer.js.map